import { IsDate, IsEnum, IsNotEmpty, IsString, Length } from 'class-validator';

export enum ProductTracelogType {
  // Need events for Inventory counting...
  CREATED = 'CREATED',
  RECEIVED = 'RECEIVED',
  RECEPTION_CANCELED = 'RECEPTION_CANCELED',
  PICKED = 'PICKED',
  PICK_CANCELED = 'PICK_CANCELED',
  MOVEMENT = 'MOVEMENT',
}

export class ProductTracelogVm {
  @IsString()
  @IsNotEmpty()
  productId: string;

  @IsString()
  @Length(1, 100)
  @IsNotEmpty()
  batch: string;

  @IsString()
  @Length(1, 100)
  @IsNotEmpty()
  serialNumber: string;

  @IsEnum(ProductTracelogType)
  @IsNotEmpty()
  type: ProductTracelogType;

  @IsDate()
  @IsNotEmpty()
  ocurredAt: Date;
}
